import { FetchDatasetsRoutine, FetchSimulationsRoutine } from '../redux-routines';
import { DATASETS_MODULES } from '../../../../common/constants';

const initialStats = {
  totalCount: 0,
  labels: [],
  data: []
};
const datasetsModules = {};
datasetsModules[DATASETS_MODULES.TRAJECTORY] = 0;
datasetsModules[DATASETS_MODULES.ANTI_COLLISION] = 0;
datasetsModules[DATASETS_MODULES.SECTION_DETAILS] = 0;
datasetsModules[DATASETS_MODULES.LOAD_CASES] = 0;
datasetsModules[DATASETS_MODULES.THERMAL_SIMULATIONS] = 0;
datasetsModules[DATASETS_MODULES.AFE_APB] = 0;
datasetsModules[DATASETS_MODULES.BLOWOUT_SIMULATIONS] = 0;
datasetsModules[DATASETS_MODULES.KILL_SIMULATIONS] = 0;

export const initialState = {
  isFetchingDatasets: false,
  isFetchingSimulations: false,
  data: {
    datasets: {
      created: {
        ...initialStats
      },
      completed: {
        ...initialStats
      },
      wellsDesigned: {
        ...initialStats
      }
    },
    datasetsModules,
    simulations: {
      kill: {
        ...initialStats
      },
      blowout: {
        ...initialStats
      }
    }
  },
  error: null
};

export const chartsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FetchDatasetsRoutine.REQUEST:
      return {
        ...state,
        isFetchingDatasets: true,
        error: null
      };
    case FetchDatasetsRoutine.SUCCESS:
      const ds = {
        ...state,
        isFetchingDatasets: false,
        error: null,
      };
      ds.data.datasets = action.payload.datasets;
      ds.data.datasetsModules = action.payload.datasetsModules;
      return ds;
    case FetchDatasetsRoutine.FAILURE:
      return {
        ...state,
        isFetchingDatasets: false,
        error: action.payload
      };
    case FetchSimulationsRoutine.REQUEST:
      return {
        ...state,
        isFetchingSimulations: true,
        error: null
      };
    case FetchSimulationsRoutine.SUCCESS:
      const sim = {
        ...state,
        isFetchingSimulations: false,
        error: null,
      };
      sim.data.simulations = action.payload.simulations;
      return sim;
    case FetchSimulationsRoutine.FAILURE:
      return {
        ...state,
        isFetchingSimulations: false,
        error: action.payload
      };
    default:
      return state;
  }
};
